import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Base URL for API
const BASE_URL = `${API_URL}/purchases`;

// Async thunks
export const fetchPurchases = createAsyncThunk('purchases/fetchAll', async (id) => {
  const response = await axios.get(`${BASE_URL}/${id}`);
  return response.data;
});

export const createPurchase = createAsyncThunk('purchases/create', async (purchase) => {
  const response = await axios.post(BASE_URL, purchase);
  return response.data;
});

export const updatePurchase = createAsyncThunk('purchases/update', async ({ id, purchase }) => {
  const response = await axios.put(`${BASE_URL}/${id}`, purchase);
  return response.data;
});

export const deletePurchase = createAsyncThunk('purchases/delete', async (id) => {
  await axios.delete(`${BASE_URL}/${id}`);
  return id;
});

// Slice
const purchasesSlice = createSlice({
  name: 'purchases',
  initialState: {
    purchases: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchases.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPurchases.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.purchases = action.payload;
      })
      .addCase(fetchPurchases.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(createPurchase.fulfilled, (state, action) => {
        state.purchases.push(action.payload);
      })
      .addCase(updatePurchase.fulfilled, (state, action) => {
        const index = state.purchases.findIndex((pur) => pur.id === action.payload.id);
        if (index !== -1) {
          state.purchases[index] = action.payload;
        }
      })
      .addCase(deletePurchase.fulfilled, (state, action) => {
        state.purchases = state.purchases.filter((pur) => pur.id !== action.payload);
      });
  },
});

export default purchasesSlice.reducer;
